import { render, staticRenderFns } from "./FilterPaketNew.vue?vue&type=template&id=477f4b00&"
import script from "./FilterPaketNew.vue?vue&type=script&lang=js&"
export * from "./FilterPaketNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports